/**
 * Created by rjulius on 3/28/16.
 */
import urlapi from "common/managers/urlapi";
import formOps from "common/datasources/form/formOperations";
var helper = {
    MISSING_ID: "MISSING_ID",

    /**
     * Return an object that describes how a particular form url api call should be handled.
     * @param params URL API parameters
     * @returns {*} Returns an object describing the form call.
     */
    classify: function(params) {

        var promise = $.Deferred();
        var formId = params.formdesignid,
            formName = params.formname,
            formInstanceId = params.formid,
            docId = params.docid;

        if (!formId && !formName && !formInstanceId && !docId) {
            return $.Deferred().resolve({
                display: helper.MISSING_ID
            }).promise();
        }

        var mode = "edit";
        if (params.mode) {
            mode = params.mode.toLowerCase();
        }
        var args = urlapi.getDynamicParameters(params); //Args for form control values
        var paramObj = {
            inType: formId ? "FORMID" : (formName ? "FORMNAME" : (formInstanceId ? "INSTANCEID" : "DOCID")),
            entityId: formId || formName || formInstanceId || docId,
            inputs: args
        };

        formOps.getFormUrlApiParams(paramObj).done(function(data) {
                var form = {
                    formId: formId,
                    formName: formName,
                    // id must exist, but can be null. Otherwise, this will be treated as an update by the Kendo DS.
                    id: formInstanceId || null,
                    docId: docId
                };
                if (data.length > 0) {
                    form.formData = data;
                }

                return promise.resolve({
                    form: form,
                    mode: mode
                }).promise();
            })
            .fail(function() {
                return promise.reject().promise();
            });

        return promise;
    }
};
export default helper;
